<template>
    <div class="base-gift-pack-details" :class="{'details-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">礼包详情</div>
                <div class="service-img" @click="$router.push('/base-service')">
                    <img class="ser" src="~images/user_service.png" />
                </div>
            </div>
            <div class="content-auto" v-show="isyes">
                <div class="title">{{objData.pack_name}}</div>
                <div class="head-bg">
                    <div class="item">礼包剩余：{{getScale(objData.pack_get_counts, objData.pack_counts)}}%</div>
                    <div class="item">有效期至：{{objData.finsh_time | dateTime}}</div>
                </div>
                <div class="content-bottom">
                    <div class="problem">
                        <div class="line"></div>
                        <div>礼包内容</div>
                    </div>
                    <div class="con">{{objData.pack_abstract}}</div>
                    <div class="problem">
                        <div class="line"></div>
                        <div>领取要求</div>
                    </div>
                    <div class="con">{{objData.pack_notice}}</div>
                    <div class="problem">
                        <div class="line"></div>
                        <div>使用方法</div>
                    </div>
                    <div class="con">{{objData.pack_method}}</div>
                    <div class="problem">
                        <div class="line"></div>
                        <div>适用范围</div>
                    </div>
                    <div class="con">{{objData.server_name || '全服'}}</div>
                </div>
                <transition name="component-fade" mode="out-in">
                    <BaseSuccess :cardNum='cardNum' @childSucce='childSucce' v-if="issucce" />
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
        <div class="btn copy" @click="onReceive">
            <span v-if="$route.query.code">复制</span>
            <span v-else>立即领取</span>
        </div>
    </div>
</template>

<script>
    import BaseSuccess from './BasePopup/BaseSuccess'
    import moment      from 'moment'
    import TheTips     from '@/components/TheTips'
    import Clipboard   from 'clipboard'

    export default {
        // 进入路由之前
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.getDetails()
            })
        },
        name: 'BaseGiftPackDetails',
        components: {
            BaseSuccess,
            TheTips
        },
        data () {
            return {
                msg: null,
                issucce: false,
                accountData: {},
                objData: {},
                cardNum: '',
                isyes: false,
                h5LoginData:{}
            }
        },
        computed: {
            getScale () {
                return (pack_used_counts, pack_counts) => {
                    if (pack_counts <= 0) {
                        return 0
                    } else {
                        return Number.parseInt(100 - (pack_used_counts / pack_counts) * 100)
                    }
                }
            }
        },
        filters: {
            dateTime (time) {
                return moment.unix(time).format('YYYY-MM-DD')
            }
        },
        methods: {
            childSucce (event) {
                this.issucce = event
            },
            onReceive () {
                if (!this.$route.query.code) {
                    this.getNum()
                } else {
                    this.onCopy(this.$route.query.code)
                }
            },
            onCopy (code) {
                let that = this
                let clipboard = new Clipboard('.copy', {
                    text () {
                        return code
                    }
                })
                clipboard.on("success", e => {
                    that.msg = '复制成功'
                    setTimeout(() => {
                        that.msg = null
                    }, 1000)
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on("error", e => {
                    that.msg = '复制失败'
                    setTimeout(() => {
                        that.msg = null
                    }, 1000)
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.onClick(event)
            },
            // 领取礼包
            getNum () {
                let options = {
                    appid: this.accountData.appid,
                    channel: this.accountData.channel ? this.accountData.channel :this.h5LoginData.channel,
                    uid: this.accountData.uid,
                    pid: this.$route.query.id,
                    machine_code: this.accountData.machine_code
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                //发起请求
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=package&a=getPackageCode', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        if(res.data.data) {
                            this.cardNum = res.data.data.card
                            this.issucce = true
                            // this.msg = '领取礼包码成功'
                            // setTimeout(() => {
                            //     this.msg = null
                            // }, 1000)
                        } else {
                            this.msg = '领取礼包码失败'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 礼包详情
            getDetails () {
                let options = {
                    appid: this.accountData.appid,
                    channel: this.accountData.channel ? this.accountData.channel :this.h5LoginData.channel,
                    uid: this.accountData.uid,
                    pid: this.$route.query.id,
                    machine_code: this.accountData.machine_code
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post("https://sdk.gameschain.pro/index.php?g=api&m=package&a=packageInfo", this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.objData = res.data.data
                        this.isyes = true
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-gift-pack-details {
        width: 1080px;
        height: 100%;
        padding-bottom: 60px;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
                .service-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .ser {
                        width: 72px;
                        height: 72px;
                    }
                }
            }
            .content-auto {
                flex: 1;
                overflow-y: scroll;
                padding: 0 105px;
                .title {
                    font-size: 42px;
                    text-align: center;
                    margin: 100px 0 50px;
                }
                .head-bg {
                    height: 60px;
                    border-radius: 30px;
                    background: rgba(255, 255, 255, 0.2);
                    display: flex;
                    align-items: center;
                }
                .head-bg .item {
                    width: 50%;
                    height: 36px;
                    font-size: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .head-bg .item:first-child {
                    border-right: 2px solid rgba(255, 255, 255, 0.2);
                }
                .content-bottom {
                    padding: 40px 0 60px;
                    overflow: hidden;
                }
                .problem {
                    font-size: 45px;
                    margin: 60px 0 10px;
                    display: flex;
                    align-items: center;
                    .line {
                        width: 12px;
                        height: 24px;
                        background: $color;
                        margin: 5px 19px 0 0;
                    }
                }
                .con {
                    font-size: 36px;
                    color: rgba(255, 255, 255, 0.5);
                }
            }
        }
        .btn {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin: 0 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // 竖屏css
    .details-sp {
        width: 100%;
        height: 100%;
        padding-bottom: 90px;
        .content {
            .header {
                height: 240px;
                border-radius: 60px 0 0 0;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
                .service-img {
                    width: 290px;
                    height: 240px;
                    .ser {
                        width: 130px;
                        height: 130px;
                    }
                }
            }
            .content-auto {
                padding: 0 100px;
                .title {
                    font-size: 76px;
                    margin: 160px 0 90px;
                }
                .head-bg {
                    height: 100px;
                    border-radius: 54px;
                }
                .head-bg .item {
                    height: 65px;
                    font-size: 54px;
                }
                .head-bg .item:first-child {
                    border-right: 3px solid rgba(255, 255, 255, 0.2);
                }
                .content-bottom {
                    padding: 72px 0 90px;
                }
                .problem {
                    font-size: 81px;
                    margin: 90px 0 18px;
                    .line {
                        width: 21px;
                        height: 43px;
                        margin: 9px 34px 0 0;
                    }
                }
                .con {
                    font-size: 65px;
                }
            }
        }
        .btn {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin: 0 90px;
        }
    }
</style>